export const APP_CONFIGURATIONS = {
	SHOW_PRICE_ELASTICY: true,
};
